<script setup lang="ts">
import { useAllStores } from '@/store'

const { organizationStore, router, t } = useAllStores()

const props = defineProps({
  id: {
    type: String,
    required: true
  },
  title: {
    type: String,
    required: true
  },
  role: {
    type: String,
    required: true
  },
  members: {
    type: Number,
    required: true
  },
  servers: {
    type: Number,
    required: true
  },
  selected: {
    type: Boolean,
    required: true
  }
})

async function select(id: string, name: string) {
  organizationStore.selectOrganization(id, name)
  await router.push({ name: 'servers:list' })
}

async function edit(event: Event) {
  event.stopPropagation()
  await router.push({ name: 'organizations:edit', params: { organization_id: props.id } })
}
</script>

<template>
  <div @click="select(id, title)" class="card" :class="{ selected: selected }">
    <div class="card-body">
      <img src="@/assets/organization.svg" class="mb-2" />
      <img
        v-if="role == 'owner'"
        @click="edit($event)"
        src="@/assets/pencil.svg"
        class="float-end mb-2"
      />
      <h5 class="card-title">{{ title }}</h5>
      <h6 class="card-subtitle mt-1 text-muted">{{ t(`role.${role}`) }}</h6>
      <div class="card-subtitle mt-1">
        <img src="@/assets/person.svg" class="mt-1 me-1" />
        <label class="mt-1 align-middle me-3">{{ members }}</label>
        <img src="@/assets/server.svg" class="mt-1 me-1" />
        <label class="mt-1 align-middle">{{ servers }}</label>
      </div>
    </div>
  </div>
</template>

<style scoped>
.card {
  background: #fff;
  transition:
    0.3s transform cubic-bezier(0.155, 1.105, 0.295, 1.12),
    0.3s box-shadow,
    0.3s -webkit-transform cubic-bezier(0.155, 1.105, 0.295, 1.12);
  padding: 14px 14px 14px 14px;
  cursor: pointer;
}

.selected {
  border-color: black;
}
.card:hover {
  transform: scale(1.01);
  box-shadow:
    0 10px 20px rgba(0, 0, 0, 0.12),
    0 4px 8px rgba(0, 0, 0, 0.06);
}
</style>
